import * as React from 'react';
import RCTooltip from 'rc-tooltip';
import { classes, isBrowser } from '../../helpers';
import { useTheme } from '../Theme/Theme';
import { style } from './style';
import { elevationCss } from '../../helpers/elevations';
export const Popover = (props) => {
    const theme = useTheme();
    const [childWidth, updateChildWidth] = React.useState();
    const [visible, updateVisible] = React.useState(props.visible);
    const child = React.useRef();
    const css = style(theme, props.expand || false, childWidth);
    React.useEffect(() => {
        updateVisible(props.visible);
    }, [props.visible]);
    const renderContent = () => {
        var _a;
        const { hideArrow } = props;
        return (React.createElement("div", null,
            React.createElement("div", { className: "rc-tooltip-arrow", style: { display: !hideArrow ? 'block' : 'none' } }),
            React.createElement("div", null,
                React.createElement("div", { style: (_a = props.style) === null || _a === void 0 ? void 0 : _a.content }, props.content))));
    };
    const { trigger, children, preserveOnClose, position, cover, align, animation, style: { container: containerStyle = {}, child: childStyle = {} } = {}, onVisibleChange, elevation = 12, } = props;
    if (!isBrowser) {
        return (React.createElement("div", { ref: child, style: childStyle }, React.cloneElement(children)));
    }
    return (React.createElement(RCTooltip, { placement: position, trigger: triggers(trigger), overlay: renderContent(), destroyTooltipOnHide: !preserveOnClose, overlayClassName: classes(css, elevationCss(elevation)), overlayStyle: containerStyle, onVisibleChange: (v) => {
            var _a;
            if (props.visible === undefined) {
                updateVisible(v);
            }
            updateChildWidth(((_a = child === null || child === void 0 ? void 0 : child.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 0);
            onVisibleChange && onVisibleChange(v);
        }, visible: visible, align: cover ? { points: ['tl', 't'] } : align, animation: animation },
        React.createElement("div", { className: "popover-element", ref: child, style: Object.assign({ display: 'inline-block' }, childStyle) }, React.cloneElement(children))));
};
const triggers = (t) => {
    const obj = {
        onClick: 'click',
        onHover: 'hover',
        onFocus: 'focus',
    };
    if (Array.isArray(t)) {
        return t.map((v) => obj[v]);
    }
    return [obj[t || 'onClick']];
};
Popover.defaultProps = {
    trigger: 'onClick',
    position: 'bottom',
    style: {},
    elevation: 12,
};
//# sourceMappingURL=Popover.js.map